import { TennistalkerIcon } from 'components/ui/tennistalker-logo'
import {
  currentUser,
  isBannerManager,
  isCensorManager,
} from 'helpers/authentication'
import {
  FilePlus,
  LayoutDashboard,
  Users,
  Hash,
  CreditCard,
  User,
  Server,
  List,
  Clock,
  Building,
} from 'lucide-react'
import {
  AudioWaveform,
  GalleryVerticalEnd,
  Tags,
  MessageSquareWarning,
  Merge,
  SquareM,
  Bell,
  Bug,
  ListTodo,
  Gem,
  MousePointerClick,
  Trophy,
  Menu,
} from 'lucide-react'
import { type SidebarData } from '../types'

const adminNavbar = [
  {
    title: 'General',
    items: [
      {
        title: 'Dashboard',
        url: '/',
        icon: LayoutDashboard,
      },
      {
        title: 'Aggiornamento Dati',
        url: '/aggiornamento-dati',
        icon: ListTodo,
      },
      {
        title: 'Notifiche',
        url: '/notifiche',
        icon: Bell,
      },
      {
        title: 'Codici membership',
        url: '/codici-membership',
        icon: Gem,
      },
      {
        title: 'Segnalazioni',
        url: '/segnalazioni',
        icon: MessageSquareWarning,
      },
    ],
  },
  {
    title: 'Players',
    items: [
      {
        title: 'Merge giocatori',
        url: '/merge-giocatori',
        //badge: '3',
        icon: Merge,
      },
      {
        title: 'Partite',
        url: '/partite',
        icon: SquareM,
      },
      {
        title: 'Cardinalità',
        url: '/cardinalita',
        icon: Hash,
      },
      {
        title: 'Richieste giocatori',
        url: '/richieste-giocatori',
        icon: CreditCard,
      },
    ],
  },
  {
    title: 'Users',
    items: [
      {
        title: 'Utenti',
        icon: Users,
        items: [
          {
            title: 'Users',
            url: '/utenti',
            icon: User,
          },
          {
            title: 'Club Managers',
            url: '/utenti/gestori-circoli',
            icon: Building,
          },
        ],
      },
      {
        title: 'API Data',
        icon: Server,
        items: [
          {
            title: 'Dashboard',
            url: 'https://api.tennistalker.it/rails/performance/',
            icon: LayoutDashboard,
          },
          {
            title: 'Requests analysis',
            url: 'https://api.tennistalker.it/rails/performance/requests',
            icon: List,
          },
          {
            title: 'Slow requests',
            url: 'https://api.tennistalker.it/rails/performance/slow',
            icon: Clock,
          },
          {
            title: 'Internal Server Error',
            url: 'https://api.tennistalker.it/rails/performance/crashes',
            icon: Bug,
          },
        ],
      },
    ],
  },
  {
    title: 'Eventi',
    items: [
      {
        title: 'Eventi live',
        url: '/eventi-live',
        icon: Trophy,
      },
    ],
  },
  {
    title: 'TWE',
    items: [
      {
        title: 'Prodotti più cliccati',
        url: '/twe/prodotti-piu-cliccati',
        icon: MousePointerClick,
      },
    ],
  },
  {
    title: 'Banner',
    items: [
      {
        title: 'Custom Banner',
        url: '/custom-banner',
        icon: FilePlus,
      },

      {
        title: 'Gestione Banner',
        url: '/gestione-banner',
        icon: Tags,
      },
      {
        title: 'Menu aggiuntivo',
        url: '/menu-aggiuntivo',
        icon: Menu,
      },
    ],
  },
]

const bannerManagerNavbar = [
  {
    title: 'General',
    items: [
      {
        title: 'Dashboard',
        url: '/',
        icon: LayoutDashboard,
      },
    ],
  },

  {
    title: 'Banner',
    items: [
      {
        title: 'Custom Banner',
        url: '/custom-banner',
        icon: FilePlus,
      },

      {
        title: 'Gestione Banner',
        url: '/gestione-banner',
        icon: Tags,
      },
      {
        title: 'Menu aggiuntivo',
        url: '/menu-aggiuntivo',
        icon: Menu,
      },
    ],
  },
]

const censorManagerNavbar = [
  {
    title: 'General',
    items: [
      {
        title: 'Dashboard',
        url: '/',
        icon: LayoutDashboard,
      },
      {
        title: 'Segnalazioni',
        url: '/segnalazioni',
        icon: MessageSquareWarning,
      },
    ],
  },

  {
    title: 'Users',
    items: [
      {
        title: 'Utenti',
        icon: Users,
        items: [
          {
            title: 'Users',
            url: '/utenti',
            icon: User,
          },
        ],
      },
    ],
  },
]

export const sidebarData: SidebarData = {
  user: {
    name: currentUser()?.name || 'Not logged in',
    email: currentUser()?.email || 'Not logged in',
    avatar:
      currentUser()?.photo_url ||
      'https://i.pravatar.cc/150?u=a042581f4e29026704d',
  },
  teams: [
    {
      name: 'Tennistalker Admin',
      logo: TennistalkerIcon,
      plan: 'tennistalker.it',
      link: 'https://www.backoffice.tennistalker.it/',
    },
    {
      name: 'Magazine',
      logo: GalleryVerticalEnd,
      plan: 'TODO',
      link: 'https://magazine.tennistalker.it/wp-admin/',
    },
    {
      name: 'Shop',
      logo: AudioWaveform,
      plan: 'TODO',
      link: 'https://admin.shopify.com/store/tennistalker',
    },
  ],
  navGroups: isBannerManager()
    ? bannerManagerNavbar
    : isCensorManager()
      ? censorManagerNavbar
      : adminNavbar,
}
